export default __webpack_public_path__ + "static/media/PawelBochnowski_Eurobank.0506ab97.png";